export const UPDATE_APP_SETTINGS = 'UPDATE_APP_SETTINGS';
export const NEW_ROUTE = 'NEW_ROUTE';

export function newRoute(newView) {
  return { type: NEW_ROUTE, state: { route: newView } };
}
